import React, { useState, useEffect } from 'react';
import {Card, Container} from "react-bootstrap";
import './commitees.css';
import Papa from 'papaparse';

const Commitees = () => {
    const [tpsCsvData, setTpsCsvData] = useState([]);
    const [intCsvData, setIntCsvData] = useState([]);
    const [natCsvData, setNatCsvData] = useState([]);

    useEffect(() => {
        async function getData() {
            // Read TPS Member
            const tpsMember = await fetch("/member2025u.csv");
            const tpsReader = tpsMember.body.getReader();
            const tpsResult = await tpsReader.read(); // raw array
            const decoder = new TextDecoder("utf-8");
            const tpsCSV = decoder.decode(tpsResult.value); // the csv text
            const tpsResults = Papa.parse(tpsCSV, { header: false }); // object with { data, errors, meta }
            const tpsRows = tpsResults.data; // array of objects
            setTpsCsvData(tpsRows);

             // Read Int Member
            const intMember = await fetch("/Internationalnew.csv");
            const intReader = intMember.body.getReader();
            const intResult = await intReader.read(); // raw array
            const intDecoder = new TextDecoder("utf-8");
            const intCSV = intDecoder.decode(intResult.value); // the csv text
            const intResults = Papa.parse(intCSV, { header: false }); // object with { data, errors, meta }
            const intRows = intResults.data; // array of objects
            setIntCsvData(intRows);

            const natMember = await fetch("/Nationalnew.csv");
            const natReader = natMember.body.getReader();
            const natResult = await natReader.read(); // raw array
            const natDecoder = new TextDecoder("utf-8");
            const natCSV = natDecoder.decode(natResult.value); // the csv text
            const natResults = Papa.parse(natCSV, { header: false }); // object with { data, errors, meta }
            const natRows = natResults.data; // array of objects
            setNatCsvData(natRows);
        }
        getData();
    }, []);


     const listItemsTPS = tpsCsvData.slice(1, tpsCsvData.length-1).map((item, index) =>
          <Card.Text key={Math.random()} className="mb-2" style={{textAlign: "left"}}>
             <span className='fw-bold'>{item[0]}</span>, {item[1]}, {item[2]}
         </Card.Text>

        );

      const listItemsINT = intCsvData.slice(1, intCsvData.length-1).map((item, index) =>
          <Card.Text key={Math.random()}>
             <span className='fw-bold'>{item[0]}</span> <br/>{item[1]}, {item[2]}
         </Card.Text>

        );

       const listItemsNAT = natCsvData.slice(1, natCsvData.length-1).map((item, index) =>
          <Card.Text key={Math.random()}>
             <span className='fw-bold'>{item[0]}</span> <br/>{item[1]}, {item[2]}
         </Card.Text>

        );


    return (
        <Container>
            <h2 className="pt-4 title">COMMITTEES</h2>
            {/*<p className="d-flex justify-content-center align-items-center text-success fw-bold" >To Be Announced (TBA)</p>*/}
            <div className="row">
                <div className="col-md-4">
                    <Card className="shadow text-center" data-aos="fade-up">
                        <center><Card.Header className="title_committee">Organizing Committee</Card.Header></center>
                        <Card.Body>
                            <Card.Title className="title_designation">Chief Patron</Card.Title>
                            <Card.Text>
                                {/*<span className='fw-bold'>Md. Habibur Rahman</span> <br/>*/}
                                Vice-Chancellor, DUET, Bangladesh
                            </Card.Text>

                            <Card.Title className="title_designation">Patron</Card.Title>
                            <Card.Text>
                                {/*<span className='fw-bold'>Mohammad Abdur Rashid</span> <br/>*/}
                                Pro-Vice-Chancellor, DUET, Bangladesh
                            </Card.Text>
                            <Card.Title className="title_designation">General Chair</Card.Title>
                            <Card.Text>
                                <span className='fw-bold'>Rafiqul Islam</span> <br/>
                                DUET, Bangladesh

                            </Card.Text>
                            <Card.Title className="title_designation">General Co-Chair</Card.Title>
                            <Card.Text>
                                <span className='fw-bold'> Mohammod Abul Kashem</span> <br/>
                                DUET, Bangladesh
                            </Card.Text>
                            <Card.Title className="title_designation">Organizing Chair</Card.Title>
                            <Card.Text>
                                <span className='fw-bold'>Md. Nasim Akhtar</span> <br/>
                                DUET, Bangladesh
                            </Card.Text>
                            <Card.Title className="title_designation">Organizing Co-Chair</Card.Title>
                            <Card.Text>
                                <span className='fw-bold'> Fazlul Hasan Siddiqui</span> <br/>
                                DUET, Bangladesh
                            </Card.Text>
                            {/*<Card.Title className="title_designation">Organizing Co-Chair</Card.Title>*/}
                            {/*<Card.Text>*/}
                            {/*    <span className='fw-bold'>Md. Zahidul Islam</span> <br/>*/}
                            {/*    IU, Kushtia, Bangladesh*/}
                            {/*</Card.Text>*/}

                            <Card.Title className="title_designation">Organizing Secretary</Card.Title>
                            <Card.Text>
                                <span className='fw-bold'>Momotaz Begum</span> <br/>
                                DUET, Bangladesh
                            </Card.Text>

                             <Card.Title className="title_designation">Finance Chair</Card.Title>
                            <Card.Text>
                                <span className='fw-bold'>Md. Obaidur Rahman</span> <br/>
                                DUET, Bangladesh
                            </Card.Text>
                            {/*<Card.Title className="title_designation">Technical Program Chair</Card.Title>*/}
                            {/*<Card.Text>*/}
                            {/*    <span className='fw-bold'>Fazlul Hasan Siddiqui</span> <br/>*/}
                            {/*    Professor, Dept. of CSE, DUET*/}
                            {/*</Card.Text>*/}

                        </Card.Body>
                        <center><Card.Header className="title_committee"> Venue Management Committee</Card.Header></center>
                        <Card.Body>
                            <Card.Text>
                                <span className='fw-bold'>Sumaya Kazary</span> <br/>
                                DUET, Bangladesh

                            </Card.Text>
                             <Card.Text>
                                <span className='fw-bold'>Sumaya Khatun</span> <br/>
                                DUET, Bangladesh

                            </Card.Text>
                            <Card.Text>
                                <span className='fw-bold'>Md. Mortuza Hossain</span> <br/>
                                DUET, Bangladesh

                            </Card.Text>
                             <Card.Text>
                                <span className='fw-bold'>Litan Islam</span> <br/>
                                DUET, Bangladesh

                            </Card.Text>


                        </Card.Body>
                        <center><Card.Header className="title_committee">Publication & Conference Management
                            Committee</Card.Header></center>

                        <Card.Body>
                            <Card.Text>
                                <span className='fw-bold'>Md. Shafiqul Islam</span> <br/>
                                 DUET, Bangladesh

                            </Card.Text>
                            <Card.Text>
                                <span className='fw-bold'>Md. Shohidul Islam</span> <br/>
                                 DUET, Bangladesh
                            </Card.Text>
                             <Card.Text>
                                <span className='fw-bold'>Sabah Binte Noor</span> <br/>
                                 DUET, Bangladesh
                            </Card.Text>
                            {/*<Card.Text>*/}
                            {/*    <span className='fw-bold'>Sajeeb Saha</span> <br/>*/}
                            {/*    JnU, Bangladesh*/}
                            {/*</Card.Text>*/}

                            {/*<Card.Text>*/}
                            {/*    <span className='fw-bold'>Khaleda Akther Papry</span> <br/>*/}
                            {/*    DUET, Bangladesh*/}
                            {/*</Card.Text>*/}


                        </Card.Body>

                        <center><Card.Header className="title_committee">Design and Awards Committee</Card.Header>
                        </center>

                        <Card.Body>
                             <Card.Text>
                                <span className='fw-bold'>Khawja Imran Masud</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>
                            <Card.Text>
                                <span className='fw-bold'>Umme Fawzia Rahim</span> <br/>
                                 DUET, Bangladesh

                            </Card.Text>
                             <Card.Text>
                                <span className='fw-bold'>Mst. Sumaya Khatun</span> <br/>
                                 DUET, Bangladesh

                            </Card.Text>

                            <Card.Text>
                                <span className='fw-bold'>Sumaya Khatun</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>
                            {/*<Card.Text>*/}
                            {/*    <span className='fw-bold'>Sohel Rana</span> <br/>*/}
                            {/*      DUET, Bangladesh*/}
                            {/*</Card.Text>*/}
                        </Card.Body>
                        <center><Card.Header className="title_committee">Food and Refreshment Committee</Card.Header>
                        </center>
                        <Card.Body>
                            <Card.Text>
                                <span className='fw-bold'>Md. Jakirul Islam</span><br/>
                                  DUET, Bangladesh

                            </Card.Text>
                            <Card.Text>
                                <span className='fw-bold'>Md. Abu Bakkar Siddique</span><br/>
                                  DUET, Bangladesh
                            </Card.Text>
                              <Card.Text>
                                <span className='fw-bold'>Md. Rajibul Islam</span><br/>
                                  DUET, Bangladesh
                            </Card.Text>

                        </Card.Body>


                        <center><Card.Header className="title_committee">Registration and Conference Kit Committee</Card.Header>
                        </center>

                        <Card.Body>
                            <Card.Text>
                                <span className='fw-bold'>Sumaya Kazary</span> <br/>
                                 DUET, Bangladesh
                            </Card.Text>
                            <Card.Text>
                                <span className='fw-bold'>Umme Fawzia Rahim</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>
                            <Card.Text>
                                <span className='fw-bold'>Md. Mortuza Hossain</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>
                        </Card.Body>
                        <center><Card.Header className="title_committee">Transport and Accommodation Committee</Card.Header>
                        </center>

                        <Card.Body>
                            <Card.Text>
                                <span className='fw-bold'>Amran Hossain </span> <br/>
                                 DUET, Bangladesh

                            </Card.Text>
                            <Card.Text>
                                <span className='fw-bold'>Md. Abu Bakkar Siddique</span> <br/>
                                 DUET, Bangladesh

                            </Card.Text>
                             <Card.Text>
                                <span className='fw-bold'>Md. Rajibul Islam</span><br/>
                                  DUET, Bangladesh
                            </Card.Text>
                            <Card.Text>
                                <span className='fw-bold'>Md. Nazmul Hasan Sakib</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>
                        </Card.Body>
                        <center><Card.Header className="title_committee">Media and Publicity Committee</Card.Header>
                        </center>

                        <Card.Body>
                            <Card.Text>
                                <span className='fw-bold'>Khawja Imran Masud</span> <br/>
                                 DUET, Bangladesh

                            </Card.Text>
                              <Card.Text>
                                <span className='fw-bold'>Md. Abu Bakkar Siddique</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>
                             <Card.Text>
                                <span className='fw-bold'> Sohel Rana</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>
                            <Card.Text>
                                <span className='fw-bold'>Litan Islam</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>



                        </Card.Body>
                        <center><Card.Header className="title_committee">Session Schedule Management Committee</Card.Header>
                        </center>

                        <Card.Body>
                            <Card.Text>
                                <span className='fw-bold'>Momotaz Begum</span> <br/>
                                 DUET, Bangladesh

                            </Card.Text>
                              <Card.Text>
                                <span className='fw-bold'>Amran Hossain</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>
                             <Card.Text>
                                <span className='fw-bold'> Sabah Bine Noor</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>
                            <Card.Text>
                                <span className='fw-bold'>Md. Abu Bakkar Siddique</span> <br/>
                                  DUET, Bangladesh
                            </Card.Text>



                        </Card.Body>
                    </Card>
                </div>
                <div className="col-md-4">
                    <Card className="shadow text-center" data-aos="fade-up">
                        <center><Card.Header className="title_committee">Technical Program Committee</Card.Header>
                        </center>
                        <Card.Body>
                            <Card.Title className="title_designation">Chair</Card.Title>
                            <Card.Text>
                                <span className='fw-bold'>Mohammad Abdur Rouf</span> <br/>
                                DUET, Bangladesh
                            </Card.Text>

                            <Card.Title className="title_designation">Co-Chair</Card.Title>
                            <Card.Text>
                                <span className='fw-bold'>Md. Shafiqul Islam</span> <br/>
                               DUET, Bangladesh
                            </Card.Text>

                            <Card.Title className="title_designation">Secretary</Card.Title>
                            <Card.Text>
                                <span className='fw-bold'> Amran Hossain</span> <br/>
                               DUET, Bangladesh
                            </Card.Text>
                              <Card.Text>
                                <span className='fw-bold'> Md. Jakirul Islam</span> <br/>
                               DUET, Bangladesh
                            </Card.Text>


                            <Card.Title className="title_designation">Members</Card.Title>

                            {listItemsTPS}



                        </Card.Body>
                    </Card>
                </div>
                <div className="col-md-4">
                    <Card className="shadow text-center" data-aos="fade-up">
                        <center><Card.Header className="title_committee">International Advisory Committee</Card.Header>
                        </center>
                        <Card.Body>
                            {/*TBA*/}

                            {listItemsINT}



                        </Card.Body>

                        <center><Card.Header className="title_committee">National Advisory Committee</Card.Header>
                        </center>
                        <Card.Body>
                            {/*TBA*/}
                            {listItemsNAT}


                        </Card.Body>
                    </Card>
                </div>

            </div>
        </Container>
    );

}

export default Commitees;